module.exports = __webpack_public_path__ + "static/media/tv.67ac70d9.svg";